import { mapState } from "vuex";
import CompReward from "./popup/reword.vue";
import { goToLogin } from "@/utils/user";
import CompLottieAnimation from "../lottieAnimation.vue";
export default {
  props: ["product_info", "mina_focus"],
  emits: ["onFavor", "getWxScheme"],
  components: {
    CompReward,
    CompLottieAnimation
  },
  computed: {
    ...mapState({
      ifLogin: state => state.user.ifLogin // 是否登录
    })
  },
  data() {
    return {
      show: false,
      showLottie: false,
      reward_id: '',
      //选中的reward_id
      parentElement: null,
      isTriggered: false // 只触发一次
    };
  },
  watch: {
    product_info(val) {
      if (val.status_code == 0 && !val.if_favor && !this.isTriggered) {
        this.triggerOnce();
      }
    }
  },
  methods: {
    // 看好动画 --- start
    triggerOnce() {
      this.parentElement = this.$parent.$el;
      if (this.parentElement) {
        this.parentElement.addEventListener('scroll', this.handleScroll);
      }
      this.isTriggered = true;
    },
    handleScroll() {
      const editorBox = this.$parent.$refs.editorBox;
      if (editorBox && this.parentElement.scrollTop > editorBox.offsetTop) {
        this.showLottie = true;
      }
    },
    removeLottieListener() {
      if (this.product_info.status_code == 0 && !this.product_info.if_favor) {
        if (this.parentElement) {
          this.parentElement.removeEventListener('scroll', this.handleScroll);
        }
      }
    },
    onAnimationComplete() {
      this.showLottie = false;
      this.removeLottieListener();
    },
    // 看好动画 --- end

    // 查看回报 
    // 立即购买支持
    onReward(reward_id) {
      this.reward_id = reward_id || '';
      if (this.product_info.is_preview) {
        this.show = true;
      } else {
        if (this.mina_focus) {
          //设置强制跳转小程序时
          this.$emit('getWxScheme');
        } else {
          if (this.ifLogin) {
            this.show = true;
          } else {
            goToLogin();
          }
        }
      }
    },
    // 看好创意
    // 看好并预约项目
    onFavor() {
      this.$emit('onFavor');
    },
    // 去商品详情
    goProduct() {
      location.href = this.product_info.advert_info.advert_url;
    },
    // 看好数量
    formatFavorCount(num) {
      if (num) {
        if (num > 10000) {
          return (num / 10000).toFixed(2) + "万";
        } else {
          return num;
        }
      } else {
        return 0;
      }
    }
  },
  unmounted() {
    this.removeLottieListener();
  }
};